module.exports = __webpack_public_path__ + "media/images/mailer-invite-e8f9b487303f79f76714f877422304ae.png";